import template from './accountPersonalization.template.html';

export default {
  template,
  bindings: {
    account: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.account = ctrl.account || {};
        ctrl.isReady = true;
      };

      ctrl.toggleDueDate = (isDueDate) => {
        if (isDueDate) {
          ctrl.account.userInterface.showTileFinanceDueDate = false;
        } else {
          ctrl.account.userInterface.showTileDueDate = false;
        }
        ctrl.saveAccount();
      };

      ctrl.saveAccount = () => {
        const data = {
          id: ctrl.account?.id,
          userInterface: ctrl.account?.userInterface || {}
        };
        ctrl.onFinished({ data });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
